import { Switch, Route, useRouteMatch } from "react-router-dom";
import { LoginScreen } from "../screens";
import routes from "./URL";
import React, { Component } from "react";
import moment from "moment";
import redux from "../common/Redux";
class AuthRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Switch>
        <Route path={routes.auth.login} component={LoginScreen} />
        <Route path={"*"} component={LoginScreen} />
      </Switch>
    );
  }
}

export default redux(AuthRoutes);

// export default function AuthRoutes() {
//     const match = useRouteMatch();
//     return (
//         <Switch>
//             <Route path={routes.auth.login} component={LoginScreen} />
//             <Route path={match.path + "*"} component={LoginScreen} />
//         </Switch>
//     );
// }
